var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#228EC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8 12.5143C10.8537 12.5143 10.0857 11.747 10.0857 10.8C10.0857 9.85303 10.8537 9.08571 11.8 9.08571C12.747 9.08571 13.5143 9.85303 13.5143 10.8C13.5143 11.747 12.747 12.5143 11.8 12.5143ZM11.8 6C9.14903 6 7 8.14903 7 10.8C7 14.2286 11.8 19.7143 11.8 19.7143C11.8 19.7143 16.6 14.2286 16.6 10.8C16.6 8.14903 14.451 6 11.8 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragMarker);
export default __webpack_public_path__ + "static/media/dragMarker.724ef4d32358a4247cf31a30ae1638b1.svg";
export { ForwardRef as ReactComponent };